export default __webpack_public_path__ + "static/media/nftArt.79304369.png";